export const testIds = {
  performanceChartPreview: 'performance-chart-preview',
};
